module.exports = __webpack_public_path__ + "media/images/avatar/development/nannies/19-7af323c188ae0b27ddbc2441827a1138.jpg";